import PropTypes from 'prop-types';

export const ScanditDefaultProps = {
  onScanResult: () => {},
};

export const ScanditPropTypes = {
  onScanResult: PropTypes.func,
};
